import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateVisibilityPayload {
    settingId: string
    data: any
    sagaCB?: {
        onSuccess: any
    }
}

export interface ICreateVisibilityState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateVisibilityState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createVisibility = createSlice({
    name: 'event-setting/createVisibility',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateVisibilityPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createVisibilityActions = createVisibility.actions
export default createVisibility.reducer
